import { usePaginatedQuery } from 'react-query';
import { listCodes } from 'src/services/api/codes';

function useListCodes(query, enabled = true) {
  return usePaginatedQuery(['codes', query], (key, query) => listCodes(query), { enabled });
}

export default useListCodes;
